import React from "react";
import styles from "./Pagination.module.scss";
import { combineClasses } from "utils/utils";
import { ReactComponent as RightChevron } from "assets/svg/RightChevron.svg";
import { ReactComponent as LeftChevron } from "assets/svg/LeftChevron.svg";

const Pagination = ({ store, handlePerPage, handlePagination }) => {
  const prevPage = (e) => {
    // setCurrPage(store?.currentPage - 1);
    handlePagination(store?.currentPage - 1);
  };
  const nextPage = (e) => {
    // setCurrPage(store?.currentPage + 1);
    handlePagination(store?.currentPage + 1);
  };
  const count = Number(Math.ceil(store?.total / store?.rowsPerPage));

  const startIndex =
    store?.rowsPerPage * store?.currentPage - store?.rowsPerPage;
  const endIndex = store?.rowsPerPage * store?.currentPage;
  return (
    <div className={styles.paginationContainer}>
      {/* <select
        onChange={
          // setPerPage(e.target.value);
          // setCurrPage(1);
          handlePerPage
          // handlePagination(1);
        }
        className={styles.dropDownStyles}
        value={store?.rowsPerPage}
      >
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select> */}
      {/* <div className={styles.paginationCount}>
        {startIndex + 1} - {store?.currentPage === count ? store.total  : endIndex} / {store.total}
      </div> */}
      {count !== 1 && (
        <div className={styles.pageNoContainer}>
          {/* <input
            type="button"
            value={<LeftChevron />}
            onClick={prevPage}
            disabled={store?.currentPage === 1}
            className={styles.paginationButton}
          /> */}
          <button
            onClick={prevPage}
            disabled={store?.currentPage === 1}
            className={styles.paginationButton}
          >
            <LeftChevron />
            <span className={styles.prevNextText}>Previous</span>
          </button>
          {/* <span className={styles.paginationButton}>
            <LeftChevron
              onClick={prevPage}
              disabled={store?.currentPage === 1}
              // className={styles.paginationButton}
              height={"20px"}
              width={"20px"}
            />
          </span> */}
          <input
            type="button"
            value="1"
            onClick={() => {
              handlePagination(1);
            }}
            disabled={store?.currentPage === 1}
            className={combineClasses(
              styles.paginationButton,
              store?.currentPage === 1 ? styles.currentPageHighlight : ""
            )}
          />
          {store?.currentPage - 2 !== 1 && store?.currentPage > 2 && "..."}
          {store?.currentPage - 1 !== 1 && store?.currentPage > 1 && (
            <input
              type="button"
              value={store?.currentPage - 1}
              onClick={() => {
                handlePagination(store?.currentPage - 1);
              }}
              className={styles.paginationButton}
            />
          )}
          {store?.currentPage !== 1 && store?.currentPage !== count && (
            <input
              type="button"
              value={store?.currentPage}
              disabled="true"
              className={combineClasses(
                styles.paginationButton,
                store?.currentPage !== 1 && store?.currentPage !== count
                  ? styles.currentPageHighlight
                  : ""
              )}
            />
          )}
          {store?.currentPage + 1 !== count && store?.currentPage < count && (
            <input
              type="button"
              value={store?.currentPage + 1}
              onClick={() => {
                handlePagination(store?.currentPage + 1);
              }}
              className={styles.paginationButton}
            />
          )}
          {store?.currentPage + 2 !== count &&
            store?.currentPage < count - 1 &&
            "..."}
          <input
            type="button"
            value={count}
            onClick={() => {
              handlePagination(count);
            }}
            disabled={store?.currentPage === count}
            className={combineClasses(
              styles.paginationButton,
              store?.currentPage === count ? styles.currentPageHighlight : ""
            )}
          />
          {/* <input
            type="button"
            value={<RightChevron />}
            onClick={nextPage}
            disabled={store?.currentPage === count}
            className={styles.paginationButton}
          /> */}
          {/* <span className={styles.paginationButton}>
            <RightChevron
              onClick={nextPage}
              disabled={store?.currentPage === count}
              // className={styles.paginationButton}
              width={"20px"}
              height={"20px"}
            />
          </span> */}
          <button
            onClick={nextPage}
            disabled={store?.currentPage === count}
            className={styles.paginationButton}
          >
            <span className={styles.prevNextText}>Next</span>
            <RightChevron />
          </button>
        </div>
      )}
    </div>
  );
};

export default Pagination;
